module.exports = __webpack_public_path__ + "static/media/ic-back.ded8caf2.svg";